<template>
  <BaseButton
    icon="arrow-left"
    inverse-icon-order
    :theme-color="!primaryColor ? 'bg-secondary text-contrast-secondary' : ''"
    :title="includeTitle ? $t('button.back') : undefined"
    :size="size"
    @click="goBack"
  />
</template>

<script>
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'

export default {
  name: 'BackButton',
  components: { BaseButton },
  props: {
    includeTitle: {
      type: Boolean,
      default: false
    },
    fallbackRoute: {
      type: [Object, String],
      required: true
    },
    primaryColor: {
      type: Boolean,
      default: false,
      required: false
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator: function (value) {
        return (
          ['extra-small', 'small', 'medium', 'large', 'extra-large'].indexOf(
            value
          ) !== -1
        )
      }
    }
  },
  methods: {
    goBack() {
      if (this.$route.redirectedFrom || window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push(this.fallbackRoute) // ou autre route nommée
      }
    }
  }
}
</script>
